import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "./store";

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()
export type NaviagtionStackType = "DashboardStack" | "SellScreenStack" | "ProductStack" | "CategoryStack" | "BrandStack" | "InventoryStack" | "OptionStack" | "ModifierScreen" | "ImageGalleryStack" | "OrdersStack" | "CustomerStack" | "CustomerGroupStack" | "StaffStack" | "InvitedStaff" | "RoleStack" | "ManualDiscountStack" | "AutomaticDiscountStack" | "BuyXgetYDiscountStack" | "PayXGetFreeStack" | "TaxStack" | "GiftStack" | "PurchaseGiftCardStack" | "IssueGiftStack" | "Plugins" | "SettingStack" | "ProfileStack"

export const getScreenPermission = (navigationName: NaviagtionStackType) => (state: RootState) => {
    const drawerMenuList = state.common.drawerMenuList ?? [];

    for (const item of drawerMenuList) {
        if (item?.subMenu && item.subMenu.length > 0) {
            const subMenu = item.subMenu.find((sub) => sub?.navigation === navigationName);
            if (subMenu) {
                return { isRead: Boolean(subMenu.isRead), isWrite: Boolean(subMenu.isWrite) };
            }
        } else {
            if (item?.navigation === navigationName) {
                return { isRead: Boolean(item?.isRead), isWrite: Boolean(item?.isWrite) };
            }
        }
    }

    return { isRead: false, isWrite: false };
};